var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "company-management-container" },
    [
      _c(
        "Card",
        {
          staticClass: "main-card",
          attrs: { padding: 0, bordered: false, "dis-hover": true },
        },
        [
          _c("div", { staticClass: "header-section" }, [
            _c(
              "div",
              { staticClass: "header-title" },
              [
                _c("Icon", {
                  attrs: {
                    type: "ios-briefcase",
                    size: "24",
                    color: "#2d8cf0",
                  },
                }),
                _c("span", { staticClass: "title-text" }, [_vm._v("公司管理")]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "header-actions" },
              [
                _c(
                  "Button",
                  {
                    staticClass: "action-btn",
                    attrs: { type: "primary", icon: "md-add" },
                    on: { click: _vm.onCompanyCreate },
                  },
                  [_vm._v("\n                    新增公司\n                ")]
                ),
                _c(
                  "Button",
                  {
                    staticClass: "action-btn",
                    attrs: { type: "default", icon: "ios-search" },
                    on: { click: _vm.toggleSearchCard },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.mainTable.searchCardShow ? "隐藏搜索" : "展开搜索"
                        ) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "transition",
            { attrs: { name: "slide-fade" } },
            [
              _c(
                "Card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.mainTable.searchCardShow,
                      expression: "mainTable.searchCardShow",
                    },
                  ],
                  staticClass: "search-card",
                },
                [
                  _c("SearchCard", {
                    attrs: {
                      form: _vm.mainTable.searchForm,
                      "table-load-event": _vm.getCompanyList,
                      "table-search": _vm.mainTable.tableSearch,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "table-section" },
            [
              _c("PaginationTable", {
                attrs: {
                  columns: _vm.mainTable.columns,
                  data: _vm.mainTable.data,
                  loading: _vm.mainTable.loading,
                  "table-search": _vm.mainTable.tableSearch,
                  "table-load-event": _vm.getCompanyList,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("CompanyModal", { ref: "companyModal", on: { refresh: _vm.refresh } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }